import {
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DurationSerializer_getInstanceo50ej00g6vz5 as DurationSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { Companion_getInstance2nqzk98fbkur7 as Companion_getInstance } from './OtpHashAlgorithm.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { IndexSet1wbu7in7fosv3 as IndexSet } from '../../../lightningdb/Annotations.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../UUID.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0 } from '../../../UUID.js.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightningdb/HasId.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function OtpSecret$Companion$$childSerializers$_anonymous__onmcep() {
  var tmp = getKClass(Duration());
  var tmp_0 = DurationSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function OtpSecret$Companion$$childSerializers$_anonymous__onmcep_0() {
  return Companion_getInstance().k2a();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, OtpSecret$Companion$$childSerializers$_anonymous__onmcep);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g2r_1 = [null, null, null, null, null, null, tmp_1, null, lazy(tmp_2, OtpSecret$Companion$$childSerializers$_anonymous__onmcep_0), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.OtpSecret', this, 13);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('subjectType', false);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.a1b('label', false);
        tmp0_serialDesc.a1b('secretBase32', false);
        tmp0_serialDesc.a1b('issuer', false);
        tmp0_serialDesc.a1b('period', false);
        tmp0_serialDesc.a1b('digits', false);
        tmp0_serialDesc.a1b('algorithm', false);
        tmp0_serialDesc.a1b('establishedAt', true);
        tmp0_serialDesc.a1b('lastUsedAt', true);
        tmp0_serialDesc.a1b('expiresAt', true);
        tmp0_serialDesc.a1b('disabledAt', true);
        tmp0_serialDesc.c1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.p4e_1 = tmp0_serialDesc;
      }
      q4e(encoder, value) {
        var tmp0_desc = this.p4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().g2r_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.n2r_1.equals(Companion_getInstance_0().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.n2r_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.o2r_1);
        tmp1_output.a15(tmp0_desc, 2, value.p2r_1);
        tmp1_output.a15(tmp0_desc, 3, value.q2r_1);
        tmp1_output.a15(tmp0_desc, 4, value.r2r_1);
        tmp1_output.a15(tmp0_desc, 5, value.s2r_1);
        tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), new (Duration())(value.t2r_1));
        tmp1_output.v14(tmp0_desc, 7, value.u2r_1);
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.v2r_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.w2r_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), value.w2r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.x2r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), value.x2r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.y2r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), value.y2r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.z2r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), value.z2r_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.q4e(encoder, value instanceof OtpSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = 0;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance_1().g2r_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = tmp18_cached[6].f2();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp17_input.x13(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.q13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = tmp18_cached[6].f2();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp17_input.x13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.q13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return OtpSecret().r4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.p4e_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_1().g2r_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6].f2(), IntSerializer_getInstance(), tmp0_cached[8].f2(), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var OtpSecretClass;
function OtpSecret() {
  if (OtpSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        Companion_getInstance_1();
        _id = _id === VOID ? Companion_getInstance_0().k2p() : _id;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.n2r_1 = _id;
        this.o2r_1 = subjectType;
        this.p2r_1 = subjectId;
        this.q2r_1 = label;
        this.r2r_1 = secretBase32;
        this.s2r_1 = issuer;
        this.t2r_1 = period;
        this.u2r_1 = digits;
        this.v2r_1 = algorithm;
        this.w2r_1 = establishedAt;
        this.x2r_1 = lastUsedAt;
        this.y2r_1 = expiresAt;
        this.z2r_1 = disabledAt;
      }
      f40() {
        return this.n2r_1;
      }
      s4e(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (OtpSecret())(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      b2s(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.n2r_1 : _id;
        subjectType = subjectType === VOID ? this.o2r_1 : subjectType;
        subjectId = subjectId === VOID ? this.p2r_1 : subjectId;
        label = label === VOID ? this.q2r_1 : label;
        secretBase32 = secretBase32 === VOID ? this.r2r_1 : secretBase32;
        issuer = issuer === VOID ? this.s2r_1 : issuer;
        period = period === VOID ? this.t2r_1 : period;
        digits = digits === VOID ? this.u2r_1 : digits;
        algorithm = algorithm === VOID ? this.v2r_1 : algorithm;
        establishedAt = establishedAt === VOID ? this.w2r_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.x2r_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.y2r_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.z2r_1 : disabledAt;
        return $super === VOID ? this.s4e(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.s4e.call(this, _id, subjectType, subjectId, label, secretBase32, issuer, new (Duration())(period), digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'OtpSecret(_id=' + this.n2r_1.toString() + ', subjectType=' + this.o2r_1 + ', subjectId=' + this.p2r_1 + ', label=' + this.q2r_1 + ', secretBase32=' + this.r2r_1 + ', issuer=' + this.s2r_1 + ', period=' + Duration__toString_impl_8d916b(this.t2r_1) + ', digits=' + this.u2r_1 + ', algorithm=' + this.v2r_1.toString() + ', establishedAt=' + this.w2r_1.toString() + ', lastUsedAt=' + toString(this.x2r_1) + ', expiresAt=' + toString(this.y2r_1) + ', disabledAt=' + toString(this.z2r_1) + ')';
      }
      hashCode() {
        var result = this.n2r_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.o2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s2r_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.t2r_1) | 0;
        result = imul(result, 31) + this.u2r_1 | 0;
        result = imul(result, 31) + this.v2r_1.hashCode() | 0;
        result = imul(result, 31) + this.w2r_1.hashCode() | 0;
        result = imul(result, 31) + (this.x2r_1 == null ? 0 : this.x2r_1.hashCode()) | 0;
        result = imul(result, 31) + (this.y2r_1 == null ? 0 : this.y2r_1.hashCode()) | 0;
        result = imul(result, 31) + (this.z2r_1 == null ? 0 : this.z2r_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OtpSecret()))
          return false;
        if (!this.n2r_1.equals(other.n2r_1))
          return false;
        if (!(this.o2r_1 === other.o2r_1))
          return false;
        if (!(this.p2r_1 === other.p2r_1))
          return false;
        if (!(this.q2r_1 === other.q2r_1))
          return false;
        if (!(this.r2r_1 === other.r2r_1))
          return false;
        if (!(this.s2r_1 === other.s2r_1))
          return false;
        if (!(this.t2r_1 === other.t2r_1))
          return false;
        if (!(this.u2r_1 === other.u2r_1))
          return false;
        if (!this.v2r_1.equals(other.v2r_1))
          return false;
        if (!this.w2r_1.equals(other.w2r_1))
          return false;
        if (!equals(this.x2r_1, other.x2r_1))
          return false;
        if (!equals(this.y2r_1, other.y2r_1))
          return false;
        if (!equals(this.z2r_1, other.z2r_1))
          return false;
        return true;
      }
      static r4e(seen0, _id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(510 === (510 & seen0))) {
          throwMissingFieldException(seen0, 510, $serializer_getInstance().p4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.n2r_1 = Companion_getInstance_0().k2p();
        else
          $this.n2r_1 = _id;
        $this.o2r_1 = subjectType;
        $this.p2r_1 = subjectId;
        $this.q2r_1 = label;
        $this.r2r_1 = secretBase32;
        $this.s2r_1 = issuer;
        $this.t2r_1 = period;
        $this.u2r_1 = digits;
        $this.v2r_1 = algorithm;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.w2r_1 = get_default(Companion_instance).b1m();
        } else
          $this.w2r_1 = establishedAt;
        if (0 === (seen0 & 1024))
          $this.x2r_1 = null;
        else
          $this.x2r_1 = lastUsedAt;
        if (0 === (seen0 & 2048))
          $this.y2r_1 = null;
        else
          $this.y2r_1 = expiresAt;
        if (0 === (seen0 & 4096))
          $this.z2r_1 = null;
        else
          $this.z2r_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'OtpSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    OtpSecretClass = $;
  }
  return OtpSecretClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.EstablishOtp', this, 1);
        tmp0_serialDesc.a1b('label', true);
        this.t4e_1 = tmp0_serialDesc;
      }
      u4e(encoder, value) {
        var tmp0_desc = this.t4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.v4e_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.v4e_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.u4e(encoder, value instanceof EstablishOtp() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.t4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return EstablishOtp().w4e(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.t4e_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var EstablishOtpClass;
function EstablishOtp() {
  if (EstablishOtpClass === VOID) {
    class $ {
      constructor(label) {
        label = label === VOID ? null : label;
        this.v4e_1 = label;
      }
      toString() {
        return 'EstablishOtp(label=' + this.v4e_1 + ')';
      }
      hashCode() {
        return this.v4e_1 == null ? 0 : getStringHashCode(this.v4e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EstablishOtp()))
          return false;
        if (!(this.v4e_1 == other.v4e_1))
          return false;
        return true;
      }
      static w4e(seen0, label, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().t4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.v4e_1 = null;
        else
          $this.v4e_1 = label;
        return $this;
      }
    }
    initMetadataForClass($, 'EstablishOtp', EstablishOtp, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    EstablishOtpClass = $;
  }
  return EstablishOtpClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.PasswordSecret', this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('subjectType', false);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.a1b('hash', false);
        tmp0_serialDesc.a1b('hint', true);
        tmp0_serialDesc.a1b('establishedAt', true);
        tmp0_serialDesc.a1b('lastUsedAt', true);
        tmp0_serialDesc.a1b('expiresAt', true);
        tmp0_serialDesc.a1b('disabledAt', true);
        tmp0_serialDesc.c1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.x4e_1 = tmp0_serialDesc;
      }
      y4e(encoder, value) {
        var tmp0_desc = this.x4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.h2u_1.equals(Companion_getInstance_0().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.h2u_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.i2u_1);
        tmp1_output.a15(tmp0_desc, 2, value.j2u_1);
        tmp1_output.a15(tmp0_desc, 3, value.k2u_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.l2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.l2u_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.m2u_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), value.m2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.n2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), value.n2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.o2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.o2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.p2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.p2u_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.y4e(encoder, value instanceof PasswordSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return PasswordSecret().z4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.x4e_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var PasswordSecretClass;
function PasswordSecret() {
  if (PasswordSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        _id = _id === VOID ? Companion_getInstance_0().k2p() : _id;
        hint = hint === VOID ? null : hint;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.h2u_1 = _id;
        this.i2u_1 = subjectType;
        this.j2u_1 = subjectId;
        this.k2u_1 = hash;
        this.l2u_1 = hint;
        this.m2u_1 = establishedAt;
        this.n2u_1 = lastUsedAt;
        this.o2u_1 = expiresAt;
        this.p2u_1 = disabledAt;
      }
      f40() {
        return this.h2u_1;
      }
      a4f(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (PasswordSecret())(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      r2u(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.h2u_1 : _id;
        subjectType = subjectType === VOID ? this.i2u_1 : subjectType;
        subjectId = subjectId === VOID ? this.j2u_1 : subjectId;
        hash = hash === VOID ? this.k2u_1 : hash;
        hint = hint === VOID ? this.l2u_1 : hint;
        establishedAt = establishedAt === VOID ? this.m2u_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.n2u_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.o2u_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.p2u_1 : disabledAt;
        return $super === VOID ? this.a4f(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.a4f.call(this, _id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'PasswordSecret(_id=' + this.h2u_1.toString() + ', subjectType=' + this.i2u_1 + ', subjectId=' + this.j2u_1 + ', hash=' + this.k2u_1 + ', hint=' + this.l2u_1 + ', establishedAt=' + this.m2u_1.toString() + ', lastUsedAt=' + toString(this.n2u_1) + ', expiresAt=' + toString(this.o2u_1) + ', disabledAt=' + toString(this.p2u_1) + ')';
      }
      hashCode() {
        var result = this.h2u_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.i2u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j2u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k2u_1) | 0;
        result = imul(result, 31) + (this.l2u_1 == null ? 0 : getStringHashCode(this.l2u_1)) | 0;
        result = imul(result, 31) + this.m2u_1.hashCode() | 0;
        result = imul(result, 31) + (this.n2u_1 == null ? 0 : this.n2u_1.hashCode()) | 0;
        result = imul(result, 31) + (this.o2u_1 == null ? 0 : this.o2u_1.hashCode()) | 0;
        result = imul(result, 31) + (this.p2u_1 == null ? 0 : this.p2u_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PasswordSecret()))
          return false;
        if (!this.h2u_1.equals(other.h2u_1))
          return false;
        if (!(this.i2u_1 === other.i2u_1))
          return false;
        if (!(this.j2u_1 === other.j2u_1))
          return false;
        if (!(this.k2u_1 === other.k2u_1))
          return false;
        if (!(this.l2u_1 == other.l2u_1))
          return false;
        if (!this.m2u_1.equals(other.m2u_1))
          return false;
        if (!equals(this.n2u_1, other.n2u_1))
          return false;
        if (!equals(this.o2u_1, other.o2u_1))
          return false;
        if (!equals(this.p2u_1, other.p2u_1))
          return false;
        return true;
      }
      static z4e(seen0, _id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_1().x4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.h2u_1 = Companion_getInstance_0().k2p();
        else
          $this.h2u_1 = _id;
        $this.i2u_1 = subjectType;
        $this.j2u_1 = subjectId;
        $this.k2u_1 = hash;
        if (0 === (seen0 & 16))
          $this.l2u_1 = null;
        else
          $this.l2u_1 = hint;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.m2u_1 = get_default(Companion_instance).b1m();
        } else
          $this.m2u_1 = establishedAt;
        if (0 === (seen0 & 64))
          $this.n2u_1 = null;
        else
          $this.n2u_1 = lastUsedAt;
        if (0 === (seen0 & 128))
          $this.o2u_1 = null;
        else
          $this.o2u_1 = expiresAt;
        if (0 === (seen0 & 256))
          $this.p2u_1 = null;
        else
          $this.p2u_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'PasswordSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_1});
    PasswordSecretClass = $;
  }
  return PasswordSecretClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.KnownDeviceSecret', this, 9);
        tmp0_serialDesc.a1b('_id', true);
        tmp0_serialDesc.a1b('subjectType', false);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.a1b('hash', false);
        tmp0_serialDesc.a1b('deviceInfo', false);
        tmp0_serialDesc.a1b('establishedAt', true);
        tmp0_serialDesc.a1b('lastUsedAt', true);
        tmp0_serialDesc.a1b('expiresAt', true);
        tmp0_serialDesc.a1b('disabledAt', true);
        tmp0_serialDesc.c1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.b4f_1 = tmp0_serialDesc;
      }
      c4f(encoder, value) {
        var tmp0_desc = this.b4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.m2p_1.equals(Companion_getInstance_0().k2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.m2p_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.n2p_1);
        tmp1_output.a15(tmp0_desc, 2, value.o2p_1);
        tmp1_output.a15(tmp0_desc, 3, value.p2p_1);
        tmp1_output.a15(tmp0_desc, 4, value.q2p_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.r2p_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), value.r2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.s2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), value.s2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.t2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.t2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.u2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.u2p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c4f(encoder, value instanceof KnownDeviceSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return KnownDeviceSecret().d4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.b4f_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var KnownDeviceSecretClass;
function KnownDeviceSecret() {
  if (KnownDeviceSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        _id = _id === VOID ? Companion_getInstance_0().k2p() : _id;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.m2p_1 = _id;
        this.n2p_1 = subjectType;
        this.o2p_1 = subjectId;
        this.p2p_1 = hash;
        this.q2p_1 = deviceInfo;
        this.r2p_1 = establishedAt;
        this.s2p_1 = lastUsedAt;
        this.t2p_1 = expiresAt;
        this.u2p_1 = disabledAt;
      }
      f40() {
        return this.m2p_1;
      }
      e4f(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (KnownDeviceSecret())(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      w2p(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.m2p_1 : _id;
        subjectType = subjectType === VOID ? this.n2p_1 : subjectType;
        subjectId = subjectId === VOID ? this.o2p_1 : subjectId;
        hash = hash === VOID ? this.p2p_1 : hash;
        deviceInfo = deviceInfo === VOID ? this.q2p_1 : deviceInfo;
        establishedAt = establishedAt === VOID ? this.r2p_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.s2p_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.t2p_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.u2p_1 : disabledAt;
        return $super === VOID ? this.e4f(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.e4f.call(this, _id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'KnownDeviceSecret(_id=' + this.m2p_1.toString() + ', subjectType=' + this.n2p_1 + ', subjectId=' + this.o2p_1 + ', hash=' + this.p2p_1 + ', deviceInfo=' + this.q2p_1 + ', establishedAt=' + this.r2p_1.toString() + ', lastUsedAt=' + toString(this.s2p_1) + ', expiresAt=' + toString(this.t2p_1) + ', disabledAt=' + toString(this.u2p_1) + ')';
      }
      hashCode() {
        var result = this.m2p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.n2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q2p_1) | 0;
        result = imul(result, 31) + this.r2p_1.hashCode() | 0;
        result = imul(result, 31) + (this.s2p_1 == null ? 0 : this.s2p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.t2p_1 == null ? 0 : this.t2p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u2p_1 == null ? 0 : this.u2p_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceSecret()))
          return false;
        if (!this.m2p_1.equals(other.m2p_1))
          return false;
        if (!(this.n2p_1 === other.n2p_1))
          return false;
        if (!(this.o2p_1 === other.o2p_1))
          return false;
        if (!(this.p2p_1 === other.p2p_1))
          return false;
        if (!(this.q2p_1 === other.q2p_1))
          return false;
        if (!this.r2p_1.equals(other.r2p_1))
          return false;
        if (!equals(this.s2p_1, other.s2p_1))
          return false;
        if (!equals(this.t2p_1, other.t2p_1))
          return false;
        if (!equals(this.u2p_1, other.u2p_1))
          return false;
        return true;
      }
      static d4f(seen0, _id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_2().b4f_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.m2p_1 = Companion_getInstance_0().k2p();
        else
          $this.m2p_1 = _id;
        $this.n2p_1 = subjectType;
        $this.o2p_1 = subjectId;
        $this.p2p_1 = hash;
        $this.q2p_1 = deviceInfo;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.r2p_1 = get_default(Companion_instance).b1m();
        } else
          $this.r2p_1 = establishedAt;
        if (0 === (seen0 & 64))
          $this.s2p_1 = null;
        else
          $this.s2p_1 = lastUsedAt;
        if (0 === (seen0 & 128))
          $this.t2p_1 = null;
        else
          $this.t2p_1 = expiresAt;
        if (0 === (seen0 & 256))
          $this.u2p_1 = null;
        else
          $this.u2p_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_2});
    KnownDeviceSecretClass = $;
  }
  return KnownDeviceSecretClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.EstablishPassword', this, 2);
        tmp0_serialDesc.a1b('password', false);
        tmp0_serialDesc.a1b('hint', true);
        this.f4f_1 = tmp0_serialDesc;
      }
      g4f(encoder, value) {
        var tmp0_desc = this.f4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.h4f_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.i4f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.i4f_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4f(encoder, value instanceof EstablishPassword() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EstablishPassword().j4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.f4f_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var EstablishPasswordClass;
function EstablishPassword() {
  if (EstablishPasswordClass === VOID) {
    class $ {
      toString() {
        return 'EstablishPassword(password=' + this.h4f_1 + ', hint=' + this.i4f_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h4f_1);
        result = imul(result, 31) + (this.i4f_1 == null ? 0 : getStringHashCode(this.i4f_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EstablishPassword()))
          return false;
        if (!(this.h4f_1 === other.h4f_1))
          return false;
        if (!(this.i4f_1 == other.i4f_1))
          return false;
        return true;
      }
      static j4f(seen0, password, hint, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_3().f4f_1);
        }
        var $this = createThis(this);
        $this.h4f_1 = password;
        if (0 === (seen0 & 2))
          $this.i4f_1 = null;
        else
          $this.i4f_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'EstablishPassword', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    EstablishPasswordClass = $;
  }
  return EstablishPasswordClass;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_4 = new (Companion_3())();
//endregion
//region block: exports
export {
  KnownDeviceSecret as KnownDeviceSecret16p4ozzebnrjy,
  OtpSecret as OtpSecret2919vqlwy0it0,
  PasswordSecret as PasswordSecret36s6jaq76xka2,
  Companion_instance_1 as Companion_instance7fo6qco5btbo,
  Companion_instance_4 as Companion_instance3ewbpovhpt7ut,
  Companion_instance_3 as Companion_instance1fvvx9vzv7oo5,
  Companion_getInstance_1 as Companion_getInstance139kwuiq3xn4y,
  Companion_instance_2 as Companion_instance1a8y12exr3m74,
};
//endregion

//# sourceMappingURL=AuthSecrets.mjs.map
